/**
 * Shared types for job progress tracking in the frontend
 */

/**
 * Standard job status values
 */
export type JobStatus = 'pending' | 'processing' | 'completed' | 'failed';

/**
 * Response for job status queries
 */
export interface JobStatusResponse {
  /** Current status of the job */
  status: JobStatus;
  /** Progress percentage (0-100) if available */
  progress?: number;
  /** Structured progress metadata when the processor reports it. */
  message?: string;
  rules?: JobProgressRule[];
  /** Error message if job failed */
  error?: string;
}

export interface JobProgressEvent {
  jobId: string;
  queueName: string;
  progress: number;
  message?: string;
  rules?: JobProgressRule[];
  timestamp: number;
}

export type JobProgressRuleState = 'pending' | 'active' | 'done';

export interface JobProgressRule {
  name: string;
  state: JobProgressRuleState;
}

export interface JobCompletedEvent<T = unknown> {
  jobId: string;
  queueName: string;
  result: T;
  timestamp: number;
}

export interface JobErrorEvent {
  jobId: string;
  queueName: string;
  error: string;
  timestamp: number;
}

export interface SubscribedEvent {
  queueName: string;
  jobId: string;
  room: string;
}

export interface UnsubscribedEvent {
  queueName: string;
  jobId: string;
}
